import { matchPath } from 'react-router-dom';
import { Routes } from '../routes';

type RouteValue = (typeof Routes)[keyof typeof Routes];

export const REALTIME_ENABLED_ROUTES: ReadonlyArray<RouteValue> = [Routes.COMPANY_INFORMATION, Routes.HOME];

export const isRealtimeRouteEnabled = (pathname: string): boolean =>
  REALTIME_ENABLED_ROUTES.some(routePattern =>
    Boolean(
      matchPath(pathname, {
        path: routePattern,
        exact: true,
      })
    )
  );

const parseBoolean = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined || value === '') {
    return fallback;
  }

  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1';
};

const pusherKey = import.meta.env.REACT_APP_PUSHER_KEY_DLGO?.trim() || '';
const pusherCluster = import.meta.env.REACT_APP_PUSHER_CLUSTER_DLGO?.trim() || '';
const isPusherEnabledByEnv = parseBoolean(import.meta.env.REACT_APP_PUSHER_ENABLED, false);
const hasMinimumPusherConfig = Boolean(pusherKey && pusherCluster);

if (isPusherEnabledByEnv && !hasMinimumPusherConfig) {
  // Keep the app stable when env setup is incomplete.
  console.error(
    '[Realtime] Pusher was enabled but required env vars are missing: REACT_APP_PUSHER_KEY_DLGO and/or REACT_APP_PUSHER_CLUSTER_DLGO.'
  );
}

export const pusherConfig = {
  enabled: isPusherEnabledByEnv && hasMinimumPusherConfig,
  key: pusherKey,
  cluster: pusherCluster,
  forceTLS: parseBoolean(import.meta.env.REACT_APP_PUSHER_FORCE_TLS, true),
  authEndpoint: import.meta.env.REACT_APP_PUSHER_AUTH_ENDPOINT?.trim() || undefined,
} as const;
